import { globalEntitlements } from '../utils/globalEntitlements';

export const STANDARD_GOOD_STANDING_CONFIG = {
  hero: {
    buyBox: [
      {
        bulletPoints: [
          { title: 'productPage.standardGoodStanding.buyBox.bulletPoint1' },
          { title: 'productPage.standardGoodStanding.buyBox.bulletPoint2' },
          { title: 'productPage.standardGoodStanding.buyBox.bulletPoint3' },
        ],
        productName: 'productPage.standardGoodStanding.buyBox.productName',
        veloCta: {
          displayVeloCta: true,
          promptMessageId: 'productPage.standardGoodStanding.buyBox.veloCta.prompt',
          topic: 'certificate-of-good-standing',
        },
        couponBanner: {
          message: 'productPage.common.buyBox.couponBannerWfc',
        },
        interactService: {
          ctaType: 'internalCheckout',
          service: 'standard_good_standing',
        },
      },
    ],
    headerPicture: {
      src: '/s2/raster/warehouse-stock-owner.png',
      alt: 'productPage.standardGoodStanding.heroPicture.altText',
    },
    headline: 'productPage.standardGoodStanding.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.standardGoodStanding.page.subheader',
  },
  benefit: {
    title: 'productPage.standardGoodStanding.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/workspacepremiumrounded.svg',
        title: 'productPage.standardGoodStanding.valueProp.propTitle1',
        description: 'productPage.standardGoodStanding.valueProp.shortCopy1',
      },
      {
        icon: '/s2/material-icons/thumbuprounded.svg',
        title: 'productPage.standardGoodStanding.valueProp.propTitle2',
        description: 'productPage.standardGoodStanding.valueProp.shortCopy2',
      },
      {
        icon: '/s2/material-icons/accountbalancerounded.svg',
        title: 'productPage.standardGoodStanding.valueProp.propTitle3',
        description: 'productPage.standardGoodStanding.valueProp.shortCopy3',
      },
    ],
  },
  howItWorks: {
    title: 'productPage.standardGoodStanding.howItWorks.title',
    items: [
      {
        title: 'productPage.standardGoodStanding.howItWorks.step1',
        description: 'productPage.standardGoodStanding.howItWorks.shortDescription1',
      },
      {
        title: 'productPage.standardGoodStanding.howItWorks.step2',
        description: 'productPage.standardGoodStanding.howItWorks.shortDescription2',
      },
      {
        title: 'productPage.standardGoodStanding.howItWorks.step3',
        description: 'productPage.standardGoodStanding.howItWorks.shortDescription3',
      },
    ],
    image: '/s2/raster/tablet-fashion-designer.png',
    alt: 'productPage.standardGoodStanding.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true,
  },
  faqs: {
    title: 'productPage.standardGoodStanding.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.standardGoodStanding.frequentlyAskedQuestions.faq1',
        answer: 'productPage.standardGoodStanding.frequentlyAskedQuestions.faqAnswer1',
      },
      {
        question: 'productPage.standardGoodStanding.frequentlyAskedQuestions.faq2',
        answer: 'productPage.standardGoodStanding.frequentlyAskedQuestions.faqAnswer2',
      },
      {
        question: 'productPage.standardGoodStanding.frequentlyAskedQuestions.faq3',
        answer: 'productPage.standardGoodStanding.frequentlyAskedQuestions.faqAnswer3',
      },
    ],
  },
  assistance: {
    title: 'productPage.standardGoodStanding.needAssistance.title',
    getInTouch: 'productPage.standardGoodStanding.needAssistance.getInTouch',
    actions: 'productPage.standardGoodStanding.needAssistance.actions',
  },
  getBuyButtonConfig: globalEntitlements({ ctaText: 'productPage.standardGoodStanding.buyBox.buttonLabel' })
    .formedByZb()
    .businessFormed()
    .allowMultiplePurchases()
    .build(),
};
